import { 
    useState,
    useContext,
    useEffect,
    useRef,
    useCallback,
    useMemo,
    StrictMode,
    createContext
} from 'react';

import { createRoot } from 'react-dom/client';


function initBlock(target) {
    const mapBlocks = target.querySelectorAll( '[data-block-name="fma/map"]' ) 

    if ( !mapBlocks.length )
        return;

    mapBlocks.forEach( block => {
        createRoot( block ).render(
            <StrictMode>
                <Map
                    { ...JSON.parse( block.dataset.attributes ) }
                    options={ JSON.parse( block.dataset.options ) }
                />
            </StrictMode>
        )
    } )
}


document.addEventListener( 'DOMContentLoaded', ( { target } ) => {
    const formObserver = new MutationObserver( (mutationsList, observer) => {
        for ( const mutation of mutationsList ) {
            if ( mutation.type == 'childList' && mutation.addedNodes.length ) {
                for (const node of mutation.addedNodes) {
                    if ( node.nodeType == 1 ) {
                        // init blocks from update
                        initBlock( node )
                    }
                }
            }
        }
    } )

    formObserver.observe( target.body, {
        childList: true,
        subtree: true
    } )

    // init blocks from load
    initBlock( target.body )
} )